export const PaintDefaults = {
    tintColor: [1, 1, 1],
    opacity: 100,
    contrast: 0,
    brightness: 0,
    saturation: 100
};
